import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import {AngularFireDatabase} from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';

import { ToastrService } from 'toastr-ng2';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent{
  userData:any={}
  constructor(public af: AngularFireDatabase, public router:Router,public toastr: ToastrService, public authentication: AngularFireAuth) {
    this.af.object('/users/' + this.authentication.auth.currentUser.uid).subscribe(res=>{
                        console.log("Firebase res: " + JSON.stringify(res));
                        this.userData = res;
                    })
                         }

  onUpadteUser(form: NgForm){
          console.log("Users Data : "+JSON.stringify(this.userData));
  	      this.af.object('/users/'+  this.authentication.auth.currentUser.uid).update({
             	email:this.userData.email,
      	        name:this.userData.name,
      	        street:this.userData.street,
      	        city:this.userData.city,
      	        zip:this.userData.zip,
      	        country:this.userData.country,
      	        mobileNo:this.userData.mobileNo
        }).then((res)=>{
      	console.log("Success");
      	 this.toastr.success('Successfully!', ' Updated!');
      })
  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/profile/profile.component.ts